module.exports = __webpack_public_path__ + "media/img/pages/companies/comet-14d04c61221582c9f31ce80640f73ed0.png";